<template>

	<div style="font-size: 30px;">
		<div style="margin: 50px;">
			欢迎进入NSP管理后台
		</div>
	</div>

	<!-- <div style="margin: 20px;">
    <el-row style="margin-left: 30px;">
      <el-col :span="6">
        <div class="justifyContent">
          <div class="grid-content" style="background-color: rgb(209, 17, 58);">
            <p>{{data.userSum}}</p>
            <p>用户总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent">
          <div class="grid-content" style="background-color:  rgb(214, 70, 97);">
            <p>{{data.todayAddUserSum}}</p>
            <p>今日注册人数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent" style="margin-left: 0px;">
          <div></div>
          <div class="grid-content" style="background-color: rgb(37, 88, 182);">
            <p>{{data.usdtSum}}</p>
            <p>USDT总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color:rgb(45, 116, 248);">
            <p>{{data.todayUstdRechargeSum}}</p>
            <p>今日USDT充值数</p>
          </div>
        </div>
      </el-col>

    </el-row>




    <el-row style="margin-left: 30px;">
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color:rgb(34, 149, 194);">
            <p>{{data.todayUsdtExtractSum}}</p>
            <p>今日USDT提币总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color:  rgb(172, 56, 218);">
            <p>{{data.cfcmSum}}</p>
            <p>CFCM总数</p>
          </div>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color: rgb(188, 88, 247);">
            <p>{{data.cfcmTodayShiftToSum}}</p>
            <p>今日CFCM转入总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color: rgb(172, 150, 50);">
            <p>{{data.todayOrderSum1}}</p>
            <p>今日投单(定期)金额</p>
          </div>
        </div>
      </el-col>

    </el-row>

    <el-row style="margin-left: 30px;">
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color: rgb(228, 218, 75);">
            <p>{{data.todayOrderSum2}}</p>
            <p>今日投单(活期)金额</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color: rgb(228, 196, 52);">
            <p>{{data.todayOrderDemandRecordSum}}</p>
            <p>今日活期转出金额</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color: rgb(240, 192, 60);">
            <p>{{data.todayOrderSum3}}</p>
            <p>今日投单(合约)金额</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color: rgb(39, 124, 75);">
            <p>{{data.cfcSum}}</p>
            <p>CFC总数</p>
          </div>
        </div>
      </el-col>

    </el-row>



    <el-row style="margin-left: 30px;">
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color: rgb(60, 160, 90);">
            <p>{{data.cfcExtractSum}}</p>
            <p>CFC提币总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="justifyContent">
          <div></div>
          <div class="grid-content" style="background-color: rgb(70, 168, 25);">
            <p>{{data.todayCfcExtractSum}}</p>
            <p>CFC今日提币总数</p>
          </div>
        </div>
      </el-col>
    </el-row>




  </div> -->



</template>
<script>
	export default {
		data() {
			return {
				data: {}
			};
		},
		methods: {
			getHomeDate() {
				this.$api.homeDate().then((res) => {
					if (res.state == 'SUCCESS') {
						this.data = res.data
					}
				})
			},
		},
		created() {
			// this.getHomeDate()
			
		}
	};
</script>
<style scoped>
	.el-row {
		margin-bottom: 20px;
	}

	.el-col {
		border-radius: 4px;
		text-align: center;
		color: white;
		font-size: 18px;
		font-weight: bold;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 100px;
		width: 200px;
	}

	.justifyContent {
		display: flex;
		/* justify-content: space-around; */
		align-items: center;
		margin-top: 20px;

	}
</style>
